/**
 * 判断商品是否缺少可用分类，并返回需要关联淘宝商品的平台。
 * 返回空字符串表示商品不需要进入关联流程；该方法只判断单件商品，
 * 不处理包裹是否有待回答问题、品类是否完整等包裹级门禁。
 * 新版导入商品以 itemNamePlatform 识别来源平台；pddtb、1688tb
 * 等旧版淘宝关联资料继续以 traPlatform 和 itemMold 兜底判断。
 *
 * @param {Object} tpItem 包裹中的商品资料
 * @returns {string} 待关联的平台标识，或空字符串
 */
export function getCategoryAssociationPlatform (tpItem) {
  if (!tpItem) return ''

  const { itemCcName, itemMold, itemNamePlatform, traPlatform } = tpItem

  if ((itemNamePlatform === 'pinduoduo' || itemNamePlatform === 'PINDUODUO') && !itemCcName) {
    return 'pinduoduo'
  }
  if (itemNamePlatform === '1688' && !itemCcName) {
    return '1688'
  }
  if (itemNamePlatform === 'weidian' && !itemCcName) {
    return 'weidian'
  }
  if (itemNamePlatform === 'xianyu' && !itemCcName) {
    return 'xianyu'
  }
  if (traPlatform === 'pddtb' && itemMold === '0') {
    return 'pinduoduo'
  }
  if (traPlatform === '1688tb' && itemMold === '0') {
    return '1688'
  }

  return ''
}

/**
 * 在包裹商品中找出第一件需要关联淘宝分类的商品。
 * allowCategoryAssociation 由包裹的品类完整度、虚拟商品状态和待回答问题共同决定；
 * 门禁未通过时，即使单件商品缺少分类也不会进入关联流程。
 *
 * @param {Array<Object>} tpItems 包裹商品列表
 * @param {boolean} allowCategoryAssociation 是否允许当前包裹进入关联流程
 * @returns {Object|null} 第一件待关联商品；没有时返回 null
 */
export function findCategoryAssociationCandidate (tpItems, allowCategoryAssociation) {
  if (!Array.isArray(tpItems)) return null

  return tpItems.find(tpItem => {
    const platform = getCategoryAssociationPlatform(tpItem)

    // 所有平台统一受包裹品类状态与问答状态控制。
    return allowCategoryAssociation && !!platform
  }) || null
}
